import React from "react";
import { Upload, Icon } from "antd";
import { css } from "glamor";

const styles = {
    fileUpload: css({
        " .ant-upload-drag": {
            border: "1px dashed #339beb !important",
        },
    }),
    icon: css({
        color: "#1890ff !important",
    }),
};

class FileUpload extends React.Component {
    render() {
        const {
            instructions = "Click or drag files to this area to upload",
            hint = "Valid file format：.pdf, .docx, .jpg, .png",
            ...rest
        } = this.props;

        return (
            <Upload.Dragger className={styles.fileUpload} {...rest}>
                <p className="ant-upload-drag-icon">
                    <Icon className={styles.icon} type="inbox" />
                </p>
                <p className="ant-upload-text">{instructions}</p>
                <p className="ant-upload-hint">{hint}</p>
            </Upload.Dragger>
        );
    }
}

export default FileUpload;
